<template>
  <div id="app">
    <!-- <Header /> -->
    <Indexv2 />
  </div>
</template>

<script>
import Indexv2 from "./views/Indexv2.vue";
// import Header from "./components/Header";

export default {
  name: "app",
  components: {
    Indexv2
    // Header
  }
};
</script>

<style lang="scss"></style>
